import { useMutation, useQueryClient } from "@tanstack/react-query";
import { clearBettingMarketsSuspensions } from "@/api/bettingMarkets";
import { BettingMarketsQueryKeys } from "@/tanstackQuery/queries/bettingMarkets";
import type {
  ClearBettingMarketSuspensionsParams,
  BettingMarketSuspensionsEditorResponse,
} from "@/types/ApiResponses/BettingMarket";

export const useClearBettingMarketsSuspensions = (targetUsername?: string) => {
  const queryClient = useQueryClient();
  const queryKey = [BettingMarketsQueryKeys.BettingMarketsSuspensions, targetUsername];

  return useMutation({
    mutationFn: (params: ClearBettingMarketSuspensionsParams) =>
      clearBettingMarketsSuspensions(params),
    onMutate: async () => {
      await queryClient.cancelQueries({ queryKey, exact: true });

      const previousData =
        queryClient.getQueryData<BettingMarketSuspensionsEditorResponse>(queryKey);

      if (previousData) {
        queryClient.setQueryData<BettingMarketSuspensionsEditorResponse>(queryKey, {
          ...previousData,
          suspensions: {},
        });
      }

      return { previousData };
    },
    onError: (_err, _variable, context) => {
      if (context?.previousData) {
        queryClient.setQueryData(queryKey, context.previousData);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey, exact: true });
    },
  });
};
